<a href="#" class="gb_cartTtip" title="{{'generic.labels.basket' | translate}}" tabindex="0"
   [routerLink]="['/' + this.storeService.authority?.codiceIpaEnte + (isPersonalRoute | fn:getRoute.bind(this))]">
  <em class="gb-speak-none" aria-hidden="true" role="icon">
    <svg viewBox="0 0 24 24">
      <path d="M22,12c0-5.5-4.5-10-10-10C6.5,2,2,6.5,2,12s4.5,10,10,10C17.5,22,22,17.5,22,12z M6,6.4h2l0.6,1.2h8.9
c0.3,0,0.6,0.3,0.6,0.6c0,0.1,0,0.2-0.1,0.3l-2.1,3.9c-0.2,0.4-0.6,0.6-1,0.6h-4.5l-0.5,1c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.2,0.2h6.9
v1.2H9.6c-0.7,0-1.2-0.5-1.2-1.2c0-0.2,0.1-0.4,0.1-0.6l0.8-1.5L7.2,7.6H6V6.4z M16.8,17.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2
c0-0.7,0.5-1.2,1.2-1.2C16.3,16,16.8,16.5,16.8,17.2z M10.8,17.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2
C10.3,16,10.8,16.5,10.8,17.2z" />
    </svg>
  </em>
  <span>{{"generic.labels.basket" | translate}} ({{totalPayments$ | async}})</span>
</a>
<div id="gb_cartTool" aria-hidden="true" *ngIf="totalPayments$ | async as totalNumberCartPayments">
  <div class="gb_emptyCart" *ngIf="totalNumberCartPayments <= 0">{{"generic.labels.basketEmpty" | translate}}</div>
  <ng-container *ngIf="totalNumberCartPayments > 0" >
    <div class="gb_cartElem" *ngFor="let pagamento of (totalPaymentsInCarts$ | async)" >
      <span>{{pagamento.causale}}</span>
      <small>{{pagamento.intestazioneEntePlugAndPay}}</small>
      <div class="price">{{pagamento.importo | currencyFormat100}}€</div>
    </div>
  </ng-container>
</div>
